import { configureStore } from "@reduxjs/toolkit"
import sliderSlice from "./slices/sliderSlice";
import servicesSlice from "./slices/servicesSlice";
import unitSlice from "./slices/unitSlice";
import membersSlice from "./slices/membersSlice";
import dailyReviewsSlice from './slices/dailyReviewSlice';
import allTimeReviewsSlice from "./slices/allTimeReviews"
import userList  from "./slices/userListSlice";
import storeItems from "./slices/storeItems";
import userSlice from "./slices/userSlice";
import eventSlice from "./slices/eventSlice";
import gallerySlice from "./slices/gallerySlice";
import aboutSlice from "./slices/about";
import messagesSlice from "./slices/messageSlice";
import reviewsSlice from "./slices/reviewsSlice";
export const store = configureStore({
    reducer: {
        user: userSlice,
        events: eventSlice,
        storeItems,
        userList,
        sliders:sliderSlice,
        units: unitSlice,
        gallery: gallerySlice,
        services: servicesSlice,
        members: membersSlice,
        about: aboutSlice,
        messages: messagesSlice,
        reviews: reviewsSlice,
        dailyReviews: dailyReviewsSlice,
        allTimeReviews: allTimeReviewsSlice
    }
})
export default store;